module.exports = __webpack_public_path__ + "img/fr-cp.3776198d.svg";